export enum ProcessingStatus {
  Claim = 'Assessed',
  AuthorisationClaimed = 'Authorisation Claimed',
  AuthorisationComplete = 'Authorisation Complete',
  BenefitAllocated = 'Benefit Allocated',
  Captured = 'Captured',
  Locked = 'Locked',
  EligibilityComplete = 'Eligibility Complete',
  Paid = 'Paid',
  Pending = 'Pending',
  Priced = 'Priced',
  PaymentRunComplete = 'Payment Run Complete',
  ValidationComplete = 'Validation Complete',
  ReadyForSettlement = 'Ready for Settlement',
  Reversed = 'Reversed',
  UpfrontPaid = 'Upfront Paid',
  Unknown = 'Unknown'
}


/**
 * Important Note!
 * Order of following enum depends upon defined in DB `processing_status_id` COLUMN
 */
export enum ProcessingStatusDBMapping {
  Unknown = 1,
  Captured = 2,
  ValidationComplete = 3,
  BenefitAllocated = 4,
  EligibilityComplete = 5,
  Assessed = 6,
  Priced = 7,
  ReadyForSettlement = 8,
  PaymentRunComplete = 9,
  Paid = 10,
  AuthorisationComplete = 11,
  AuthorisationClaimed = 12,
  Pending = 13,
  UpfrontPaid = 14,
  Reversed = 15
}

